import PropTypes from 'prop-types';
import BaseSelectorReadonlyToInput
  from "../../component/Select/BaseSelectorReadonlyToInput";

class CheckpointIntegrationSelector extends BaseSelectorReadonlyToInput {

  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      label: 'name',
      title: 'Tipo de integração',
      items: [
        {id: 'SAME_NODE_INTEGRATION', name: 'Consumo apenas pelo mesmo Node (UUID)'},
        {id: 'MOVEMENT_ORDER', name: 'Ordem de Movimentação'},
        {id: 'POLYGON_INTEGRATION', name: 'Polígonos'},
        {id: 'MOVEMENT_ORDER_POST_TRANSACTION_END', name: 'Selecione a Ordem de Movimentação'},
        {id: 'SEND_MOVEMENT_AFTER_TRANSACTION', name: 'Envia Ordem de Movimentação após fim da transação (Não seleciona)'},
        {id: 'HTTP_REQUEST_RAW', name: 'Envio de HTTP pro Node Red'}
      ]
    };
  }
}

CheckpointIntegrationSelector.propTypes = {
  required: PropTypes.bool,
  setValue: PropTypes.func,
  defaultValue: PropTypes.string,
  readonly: PropTypes.bool,
  onChange: PropTypes.func,
};

export default CheckpointIntegrationSelector;



// WEBPACK FOOTER //
// ./src/checkpoint/integration/CheckpointIntegrationSelector.js